module.exports = __webpack_public_path__ + "img/next-arrow.97a5166e.svg";